export class BackButton {
    show = false;
    url = '';
    text = '';
    action = '';
}

export class BackButtonAction {
    type = '';
    action = '';
}

    